var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.toRoute}},[_c('v-btn',{staticClass:"mb-4 ml-0 add-button",attrs:{"depressed":"","color":"primary","dark":""}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }